import { Component, OnInit, forwardRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { 
    NavController, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { environment } from '@app/environment';
import { DemoozModalComponent, DemoozMessageComponent } from '@demooz/components';
import { ChallengesItemComponent, ChallengesResponseComponent } from '@app/components';
import { DataService } from '@app/services';
import { Challenge } from '@app/models';

export type challengeType = 'level'|'mission'|'flash'|'history';

@Component({
    selector: 'app-challenges-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => DemoozModalComponent), forwardRef(() => DemoozMessageComponent), forwardRef(() => ChallengesItemComponent), forwardRef(() => ChallengesResponseComponent)
    ]
})
export class ChallengesListComponent  implements OnInit {
      
    @Input({alias : 'challengesTypes', required : true}) challengesTypes: Array<challengeType> = ['history'];
    @Input({alias : 'maxItems', required : false}) maxItems: number;
    @Input({alias : 'challengeID', required : false}) challengeID: string;
      
    @ViewChild('modalChallenge') modalChallenge: DemoozModalComponent;
      
    challenges: Array<Challenge> = [];
    showAll: boolean = false;
    challengeSelected: Challenge|null = null;
      
    constructor(            
        private activatedRoute: ActivatedRoute,
        private navController: NavController, 
        public dataService: DataService
    ) { }

    ngOnInit() {
        this.loadChallenges();        
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['challengeID'] && changes['challengeID'].currentValue){
            if(this.challengeID && this.challengeID != ''){
                let challenge = this.challenges.find(c => c.ID === this.challengeID);
                if(challenge){
                    this.onClickChallenge(challenge);
                }
            }
        }
    }
    
    loadChallenges(){
        let challenges: Array<Challenge> = [];
        let hasChallengeDemonstrations = false;
        let hasChallengeSales = false; 
                
        if(this.challengesTypes.includes('flash')){
            let hasChallengeDemonstrationsFlash = false;
            let hasChallengeSalesFlash = false; 
            let challengesFlash = this.dataService.ambassador.challenges?.flash?.filter(c => {
                if(c.type === environment.CHALLENGE_TYPE.DEMONSTRATION){
                    hasChallengeDemonstrationsFlash = true;
                }
                if(c.type === environment.CHALLENGE_TYPE.SALE){
                    hasChallengeSalesFlash = true;
                }
                return true;
            });
            challenges = challenges.concat(challengesFlash || []);
            hasChallengeDemonstrations = hasChallengeDemonstrationsFlash;
            hasChallengeSales = hasChallengeSalesFlash;
        }        
        
        if(this.challengesTypes.includes('level')){
           let challengesLevels = this.dataService.ambassador.challenges?.levels || [];
           challengesLevels.forEach((cLevel) => {       
                let hasChallengeDemonstrationsLevel = false;
                let hasChallengeSalesLevel = false; 
                let challengesLevel = cLevel.challenges.filter(c => {
                    let check = true;
                    if(c.type === environment.CHALLENGE_TYPE.DEMONSTRATION){
                        if(hasChallengeDemonstrations){
                            check = false;
                        }
                        else{
                            hasChallengeDemonstrationsLevel = true;
                        }
                    }
                    if(c.type === environment.CHALLENGE_TYPE.SALE){
                        if(hasChallengeSales){
                            check = false;
                        }
                        else{
                            hasChallengeSalesLevel = true;
                        }
                    }                                 
                    return check;
                });               
                challenges = challenges.concat(challengesLevel);
                hasChallengeDemonstrations = hasChallengeDemonstrations || hasChallengeDemonstrationsLevel;
                hasChallengeSales = hasChallengeSales || hasChallengeSalesLevel;
           });
        }
        
        if(this.challengesTypes.includes('mission')){
            let hasChallengeDemonstrationsMission = false;
            let hasChallengeSalesMission = false; 
            let challengesMission = this.dataService.ambassador.challenges?.missions?.filter(c => {
                let check = true;
                if(c.type === environment.CHALLENGE_TYPE.DEMONSTRATION){
                    if(hasChallengeDemonstrations){
                        check = false;
                    }
                    else{
                        hasChallengeDemonstrationsMission = true;
                    }
                }
                if(c.type === environment.CHALLENGE_TYPE.SALE){
                    if(hasChallengeSales){
                        check = false;
                    }
                    else{
                        hasChallengeSalesMission = true;
                    }
                }                      
                return check;
            });
            challenges = challenges.concat(challengesMission || []);
            hasChallengeDemonstrations = hasChallengeDemonstrations || hasChallengeDemonstrationsMission;
            hasChallengeSales = hasChallengeSales || hasChallengeSalesMission;
        }        
        
        if(this.challengesTypes.includes('history')){
           challenges = challenges.concat(this.dataService.ambassador.challenges?.history || []);
        }
        
        let orderCategory: any = {'level': 1, 'flash': 2, 'mission': 3, 'history': 4};
        let orderResponse: any = {};
        orderResponse[environment.CHALLENGE_VALIDATION_TYPE.AWAITING_VALIDATION] = 1;
        orderResponse[environment.CHALLENGE_VALIDATION_TYPE.VALIDATED] = 2;
        orderResponse[environment.CHALLENGE_VALIDATION_TYPE.DENIED] = 3;
        orderResponse[environment.CHALLENGE_VALIDATION_TYPE.DENIED_DEFINITELY] = 4;
        
        challenges.sort((a, b) => {
            let aResponse = a.response;
            let bResponse = b.response;
            if(a.category === 'history' && b.category === 'history'){      
                if(aResponse && bResponse){
                    return bResponse.date.getTime() - aResponse.date.getTime();
                }
                else{
                    return 1;
                }
            }
            else{
                if(aResponse?.status === environment.CHALLENGE_VALIDATION_TYPE.DENIED && a.type !== environment.CHALLENGE_TYPE.SALE){ 
                    return -1;                    
                }
                else if(bResponse?.status === environment.CHALLENGE_VALIDATION_TYPE.DENIED && b.type !== environment.CHALLENGE_TYPE.SALE){ 
                    return 1;                    
                }
                else if(!aResponse && !bResponse){
                    if(a.category === 'level' && b.category === 'level'){
                        return parseInt(a.level) - parseInt(b.level);
                    }
                    else{                        
                        return orderCategory[a.category] - orderCategory[b.category];
                    }
                }
                else if (aResponse && bResponse){
                    return orderResponse[aResponse.status] - orderResponse[bResponse.status];
                }
                else if(!aResponse && bResponse){
                    return -1;
                }
                else{
                    return 1;
                }
            }
        });
        
        this.challenges = challenges;
    }
    
    displayAll() {
        this.showAll = true;
    }
    
    onClickChallenge(challenge: Challenge){
        if([environment.CHALLENGE_TYPE.DEMONSTRATION].indexOf(challenge.type) === -1 ){
            this.challengeSelected = challenge;
            this.modalChallenge.open();
        }
        else if(challenge.category !== 'history'){
            this.navController.navigateRoot('missions', {queryParams: {od: 1}, skipLocationChange: true});
        }
    }
    
    onDidDismissModalChallenge(event: any){
        this.challengeSelected = null;
    }
    
    onSubmitChallengeResponse(status: boolean){
        if(status){
            this.loadChallenges();
        }
        this.modalChallenge.dismiss();
    }
}
